export default __webpack_public_path__ + "static/media/logo-monster-hunter-dle.e3550cd9.webp";